import React, { useCallback, useMemo } from "react";
import type {
  GenericDonutChartRow,
  PipelineByOpportunityTypeChartProps,
  PipelineByOpportunityTypeItem,
} from "../../type";
import { useApp } from "../../../../contexts/AppContext";
import { GenericDonutChart } from "../ChartTypes/GenericDonutChart";
import { EMPTY_PIPELINE_BY_OPPORTUNITY_TYPE_MESSAGE } from "../../../../utils/consts";
import { pipelineByOpportunityChartConfig } from "./styles/pipelineHealthStyles";

const toChartRows = (
  series: PipelineByOpportunityTypeItem[],
): GenericDonutChartRow[] =>
  series.map((item) => ({
    label: item.type,
    value: item.value,
    color: item.color,
  }));

export const PipelineByOpportunityTypeChart: React.FC<
  PipelineByOpportunityTypeChartProps
> = ({ title, loading = false, series }) => {
  const { drawerOpen } = useApp();
  const rows = toChartRows(series);
  const percentageByType = useMemo(
    () =>
      Object.fromEntries(series.map((item) => [item.type, item.percentage])),
    [series],
  );

  const tooltipValueFormatter = useCallback(
    (value: number, percent: number, label?: string) => {
      const displayPercent = percentageByType[label ?? ""] ?? percent;
      return `${value.toLocaleString("en-US")} (${displayPercent.toFixed(2)}%)`;
    },
    [percentageByType],
  );

  return (
    <GenericDonutChart
      title={title}
      titleAlign={pipelineByOpportunityChartConfig.titleAlign}
      data={rows}
      loading={loading}
      height={pipelineByOpportunityChartConfig.height}
      minHeight={pipelineByOpportunityChartConfig.minHeight}
      emptyMessage={EMPTY_PIPELINE_BY_OPPORTUNITY_TYPE_MESSAGE}
      resizeTrigger={drawerOpen}
      tooltipValueFormatter={tooltipValueFormatter}
    />
  );
};
